import DataPage from '../components/DataPage';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Motion Data | Cartwheel',
  'Explore structured, high-fidelity human motion data for training, analysis, and simulation across physical and digital systems.',
);

export default DataPage;
